import cn from 'classnames'
import s from './ToggleSwitch.module.scss'

interface Props {
  value: boolean
  onChange: (newValue: boolean) => void
  labelLeft: string
  labelRight: string
  className?: string
}

const defaultProps: Partial<Props> = {
  className: undefined,
}

const ToggleSwitch = ({
  value,
  onChange,
  labelLeft,
  labelRight,
  className,
}: Props): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.checked)

  return (
    <>
      <input
        checked={value}
        onChange={handleChange}
        className={s.input}
        type="checkbox"
        id="switch"
      />
      <label className={cn(s.label, className)} htmlFor="switch">
        <span className={s.left}>{labelLeft}</span>
        <span className={s.right}>{labelRight}</span>
      </label>
    </>
  )
}

ToggleSwitch.defaultProps = defaultProps
export default ToggleSwitch
